import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MemoizedSelector, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { getAccessGuard as originalGetAccessGuard } from 'mt-ui-lib/guards/access-guard';
import { IAppState } from '@app/app.state';
import { EAccessCode } from '@app/app.enums';
import { canDeactivateWithModal } from '@shared/functions/can-deactivate-with-modal.function';

export const getAccessGuard = (
  value: EAccessCode | EAccessCode[],
  multi?: 'every' | 'some',
  redirectTo?: string,
) => originalGetAccessGuard(value, multi, redirectTo);

export const getTitle = (key: string) => {
  const translateService = inject(TranslateService);
  return translateService.get(key);
};

export const hasChangesCanDeactivate = (
  selector: MemoizedSelector<IAppState, boolean>,
): CanDeactivateFn<unknown> => {
  return () =>
    canDeactivateWithModal([inject(Store<IAppState>).select(selector)]);
};
